import { motion } from 'framer-motion';
import { Phone, Mail, MapPin } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-navy-600 text-white">
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12 max-w-6xl mx-auto">
          {/* Brand */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h3 className="text-3xl font-display font-bold mb-4">
              VISINOT<span className="text-gold-400">.</span>
            </h3>
            <p className="text-navy-200 leading-relaxed">
              Visuels, Visites et contrôles légaux pour les études notariales.
            </p>
          </motion.div>

          {/* Services */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <h4 className="font-semibold text-lg mb-4">Services</h4>
            <ul className="space-y-3">
              <li className="text-navy-200">Pack Marketing (visuels)</li>
              <li className="text-navy-200">Pack Visites</li>
              <li className="text-navy-200">Pack Contrôles (PEB & ELEC)</li>
            </ul>
          </motion.div>

          {/* Zones couvertes */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h4 className="font-semibold text-lg mb-4">Zones couvertes</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-navy-200">
                <MapPin className="w-4 h-4 text-gold-400" />
                Wallonie
              </li>
              <li className="flex items-center gap-2 text-navy-200">
                <MapPin className="w-4 h-4 text-gold-400" />
                Bruxelles
              </li>
            </ul>
          </motion.div>

          {/* Contact */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <h4 className="font-semibold text-lg mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-gold-400 flex-shrink-0 mt-0.5" />
                <a
                  href="tel:+32486494670"
                  className="text-navy-200 hover:text-gold-400 transition-colors"
                >
                  +32 486 49 46 70
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-gold-400 flex-shrink-0 mt-0.5" />
                <a
                  href="mailto:contact@visinot.be"
                  className="text-navy-200 hover:text-gold-400 transition-colors"
                >
                  contact@visinot.be
                </a>
              </li>
            </ul>
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="pt-8 border-t border-navy-500 max-w-6xl mx-auto"
        >
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-center md:text-left">
            <p className="text-navy-200 text-sm">
              &copy; {new Date().getFullYear()} VISINOT. Tous droits réservés.
            </p>
            <div className="flex gap-4 text-sm">
              <a href="/conditions-generales" className="text-navy-200 hover:text-gold-400 transition-colors">
                Mentions légales
              </a>
              <span className="text-navy-400">|</span>
              <a href="/conditions-generales" className="text-navy-200 hover:text-gold-400 transition-colors">
                Politique de confidentialité
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </footer>
  );
}
